<template>
  <div class="content animate-panel" id="content">
    <h2 class="m-n box-warehouse-amazon-title">
      <div class="warehouse-amazon-title-icon">
        <img :src="iconUrl" alt="" class="img-responsive">
      </div>
      <div class="warehouse-amazon-title">倉庫管理</div>
    </h2>
    <div class="hpanel">
      <nav-tabs :tab="tab"></nav-tabs>
      <tab-content :tab="tab"></tab-content>
    </div>
  </div>
</template>

<script>
import NavTabs from './NavTabs'
import TabContent from './TabContent'

export default {
  components: {
    NavTabs,
    TabContent
  },
  data () {
    return {
      tab: null,
      loader: null
    }
  },
  computed: {
    iconUrl () {
      return this.$store.getters.getWareHouseIcons['Amazon']
    }
  },
  mounted () {
    this.$events.listen('done', () => {
      this.loader && this.loader.hide()
    })
  },
  watch: {
    $route (to, from) {
      const fromTab = from.params.tab
      const toTab = to.params.tab
      if (fromTab !== toTab && ['top', 'amazon-info', 'multi-channel-service', 'receive-amount-setting'].includes(toTab)) {
        this.tab = toTab
      } else {
        this.$router.push('/not-found')
      }
    }
  },
  created () {
    this.tab = this.$route.params.tab
    if (['top', 'amazon-info', 'multi-channel-service', 'receive-amount-setting'].includes(this.tab)) {
      this.loader = this.$loading.show()
    } else {
      this.$router.push('/not-found')
    }
  },
  beforeDestroy () {
    this.$events.remove('done')
    this.loader && this.loader.hide()
  }
}
</script>

<style scoped>
  .box-warehouse-amazon-title {
    display: flex;
    align-items: center;
  }
  .box-warehouse-amazon-title .warehouse-amazon-title-icon {
    width: 40px;
    margin-right: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/view/warehouseAmazon/Warehouses.vue